import { useEffect, useMemo } from 'react';
import { ApolloClient, InMemoryCache, useLazyQuery } from '@apollo/client';
import { DEALER_SEARCH_API_GATEWAY_URL } from '../constants/environment';
import { GET_DEALER } from '../schemas/DealerLocationSchema';
import { DealerLocationData, DealerSearchInfo } from '../types';

const dealerSearchApolloClient = new ApolloClient({
  uri: DEALER_SEARCH_API_GATEWAY_URL,
  cache: new InMemoryCache(),
});

type UseDealerLocationData = (kvpsSyncId: string | undefined) => {
  dealer: DealerSearchInfo | undefined;
  loading: boolean;
};

interface QueryResult {
  dealerById: DealerLocationData;
}

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const market = new URLSearchParams(locationSearch).get('market') ?? 'ca';

const useDealerLocationData: UseDealerLocationData = (kvpsSyncId) => {
  const [getDealerData, { data, loading }] = useLazyQuery<QueryResult>(GET_DEALER, {
    errorPolicy: 'all',
    client: dealerSearchApolloClient,
    context: {
      headers: { clientid: 'wv2ybzheub' },
    },
  });

  useEffect(() => {
    if (!kvpsSyncId) return;

    getDealerData({
      variables: {
        dealerId: market === 'ca' || market === 'cauc' ? `CANA${kvpsSyncId}` : `USAA${kvpsSyncId}`,
      },
    });
  }, [kvpsSyncId, getDealerData]);

  const dealer = useMemo(() => {
    if (!data) return undefined;

    return {
      services: data?.dealerById?.services ?? [],
    };
  }, [data]);

  return { dealer, loading };
};

export default useDealerLocationData;
